module.exports = __webpack_public_path__ + "static/media/chevron.fa7a10aa.svg";